import { useState, useEffect, useRef } from "react";
import "./style3.scss";
import ax from "assets/images/logo.svg";
import "react-multi-date-picker/styles/layouts/prime.css";
import styles from "../bussiness.module.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Select from "react-select";
import axios from "axios";
import "./stylenew.scss";
import { HiOutlineSave } from "react-icons/hi";
import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
import { connection } from "utils/apiConnection.ts";
import toast from "react-hot-toast";
import TodoList from "../RezervTodos/TodoList/TodoList";
import TodoApp from "../RezervTodos/TodoApp/TodoApp";
import { isString } from "lodash";
import Loader from "utils/Loader";

function EditProduct({
  allLeader,
  setAllLeader,
  allProductTags,
  setAllProductTags,
  allUserTag,
  todos,
  setTodos,
  setAllUserTag,
  updater,
  setUpdater,
  otherInfo,
  setOtherInfo,
  isLoading,
  setIsLoading
}) {
  useEffect(() => {}, [otherInfo]);
  const [isLoading1, setIsLoading1] = useState(false);
  const inputElement = useRef();
  const [filterCat, setFilterCat] = useState();
  const [filterLine, setFilterLine] = useState();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [x1, setX1] = useState([]);
  console.log("otherInfo.main_", otherInfo.main_cover_file_id);
  console.log("otherInfo", otherInfo);

  function postHandler(otherInfo) {
    setIsLoading(true);
    const todoData = todos.map(val => {
      if (val.user_tag_id.value == val.user_tag_id.label) {
        return {
          id: -1,
          text: val.text,
          price: val.price,
          user_tag_id: val.user_tag_id.label
        };
      } else {
        return {
          id: val.user_tag_id.value,
          text: val.text,
          price: val.price,
          user_tag_id: val.user_tag_id.label
        };
      }
    });
    let xd = otherInfo.line_id;
    let cc = "";
    if (xd.length > 0) {
      cc = otherInfo.line_id[0].value;
    } else {
      cc = otherInfo.line_id.value;
    }
    // if (otherInfo.title == "") {
    //   toast.error("لطفا نام محصول را وارد کنید.");
    // }
    let xd2 = otherInfo.sub_line_id;
    let cc2 = "";
    if (xd2.length > 0) {
      cc2 = otherInfo.sub_line_id[0].value;
    } else {
      cc2 = otherInfo.sub_line_id.value;
    }

    let myFormData = new FormData();
    myFormData.append("product_id", otherInfo.products__id);
    myFormData.append("title", otherInfo.title);
    myFormData.append("default_price", otherInfo.default_price);
    myFormData.append("default_weight_from", otherInfo.default_weight_from);
    myFormData.append("default_weight_to", otherInfo.default_weight_to);
    myFormData.append("cat_id", otherInfo.cat_id);
    myFormData.append("line_id", cc);
    myFormData.append("main_cover_file_id", otherInfo.main_cover_file_id);
    myFormData.append("sub_line_id", cc2);
    for (let index2 = 0; index2 < todoData.length; index2++) {
      myFormData.append(`title_${[index2]}`, todoData[index2].user_tag_id);
      myFormData.append(
        `default_need_time_${[index2]}`,
        todoData[index2].text != undefined ? todoData[index2].text * 60 : "0"
      );
      myFormData.append(
        `default_price_${[index2]}`,
        todoData[index2].price != undefined ? todoData[index2].price : "0"
      );
      myFormData.append(`id_${[index2]}`, todoData[index2].id);
      myFormData.append(`option_count`, todoData.length);
    }
    myFormData.append("best_supplier_id", otherInfo.best_supplier_id.value);

    if (otherInfo.title == "") {
      toast.error("لطفا نام محصول را وارد کنید.");
      return null;
    } else {
      setDisabledBtn(true);
      axios
        .post("http://old-sabadib.tatdemo.ir/superadminapi/editproduct", myFormData)
        .then(res => {
          if (res.data.status === 1) {
            setDisabledBtn(false);
            setUpdater(!updater);
            setOtherInfo({
              title: "",
              default_price: "",
              default_weight_from: "",
              default_weight_to: "",
              cat_id: "-1",
              line_id: [],
              main_cover_file_id: [],
              best_supplier_id: ""
            });
            setimg("");

            toast.success("اطلاعات با موفقیت ثبت شد!");
            setIsLoading(false);
          } else {
            setDisabledBtn(false);
            toast.error("اطلاعات با موفقیت ثبت نشد!");
            setIsLoading(false);
          }
        });
    }

    inputElement.current.click();
  }
  function handleChange(event) {
    setOtherInfo({
      ...otherInfo,
      [event.target.name]: removeCommas(event.target.value)
    });
  }
  const changeHandleraTags = option => {
    let temp = {};
    setOtherInfo(prev => {
      temp = { ...prev };
      temp.line_id = option;

      return { ...temp };
    });
    setFilterLine(temp.line_id);
  };
  function inputChangeHandler(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }
  const [img, setimg] = useState("");
  function inputChangeHandlerDaste(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
    setFilterCat(event.target.value);
  }
  const changeHandleraSubLines = option => {
    setOtherInfo(prev => {
      let temp = { ...prev };
      temp.sub_line_id = option;
      return { ...temp };
    });
  };

  const test = allProductTags.filter(item => {
    if (allProductTags != undefined) {
      if (item.main_cat == otherInfo.cat_id && item.parent_line_id == 0) {
        return item;
      }
    }
  });

  const essen = () => {
    let x = filterLine;
    if (x != undefined) {
      return x.value;
    } else {
      // return console.log("errEsst");
    }
  };
  let subLine = [];
  if (allProductTags != undefined) {
    subLine = allProductTags.filter(item => {
      return (
        (otherInfo.line_id.length > 0 &&
          item.parent_line_id == otherInfo.line_id[0].value) ||
        item.parent_line_id == essen()
      );
    });
  }
  const [bestSupplier, setBestSupplier] = useState([]);
  useEffect(() => {
    async function loadPage() {
      let data = await connection("superadminapi/getsuppliers", {});
      let allSuppliers = [];
      for (let i = 0; i < data.data.length; i++) {
        let newObject = {};
        newObject.value = data.data[i].info.suppliers__id;
        newObject.label = data.data[i].info.title;
        allSuppliers.push(newObject);
      }
      setBestSupplier(allSuppliers);

      console.log("allsupplier :", allSuppliers);
      console.log("bestSupplier : ", bestSupplier);
      console.log("otherInfo.best_supplier_id :", otherInfo.best_supplier_id);
      // let x = [];
      // x = allSuppliers.filter(b => b.value == otherInfo.best_supplier_id);

      // setOtherInfo(prev => {
      //   return { ...prev, best_supplier_id: x };
      // });
      // }
      // });
    }
    loadPage();
  }, []);

  useEffect(() => {
    if (otherInfo.best_supplier_id != "0") {
      // setIsLoading1(true);
      async function loadPage() {
        let data = await connection("superadminapi/getsuppliers", {});
        let x = [];
        let selectedSupplier = {};
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].info.suppliers__id == otherInfo.best_supplier_id) {
            selectedSupplier.value = data.data[i].info.suppliers__id;
            selectedSupplier.label = data.data[i].info.title;
            x.push(selectedSupplier);

            setOtherInfo(prev => {
              return { ...prev, best_supplier_id: x };
            });
          }
        }
        // setIsLoading1(false);
      }

      loadPage();
    }
    setIsLoading1(false);
  }, [otherInfo.best_supplier_id]);

  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalEditProduct`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header" style={{ justifyContent: "end" }}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                ویرایش محصول
              </h5>
              <button
                type="button"
                className="btn btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body style-container edit-component"
              style={{ background: "#e7f1ff" }}
            >
              {/* {isLoading1 && <Loader />} */}
              <div className="edit-user-container">
                <form id="edit-user-form-data" className=" edit-container">
                  <div
                    className="edit-user-item mb-3 d-flex justify-content-center w-100"
                    style={{ marginTop: "-35px" }}
                  >
                    <label htmlFor="profile-pic">
                      <div className="profile-pic position-relative">
                        <input
                          className="d-none"
                          type="file"
                          accept="image/*"
                          id="ProfilePic"
                          onChange={e => {
                            setOtherInfo({
                              ...otherInfo,
                              ["main_cover_file_id"]: e.target.files[0]
                            });
                            setimg(URL.createObjectURL(e.target.files[0]));
                          }}
                        />
                        {otherInfo.main_cover_file_id == "" ? (
                          <FcPicture
                            style={{
                              width: "80px",
                              // borderRadius: "50%",
                              height: "80px",
                              overflow: "hidden"
                            }}
                          />
                        ) : (
                          <img
                            src={
                              img == ""
                                ? `${"http://sabadi.tatdemo.ir/" +
                                    otherInfo.path}`
                                : `${img}`
                            }
                            alt=""
                            style={{
                              width: "80px",
                              borderRadius: "50%",
                              height: "80px",
                              overflow: "hidden"
                            }}
                          />
                        )}

                        <label
                          htmlFor="ProfilePic"
                          className="position-absolute containBoxdark"
                          style={{
                            right: "3px",
                            top: "-10px",
                            cursor: "pointer"
                          }}
                        >
                          <FaPlusCircle />
                        </label>
                      </div>
                    </label>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color">عنوان</label>
                      <input
                        className={styles.inputSty}
                        type="text"
                        name="title"
                        value={otherInfo.title}
                        onChange={inputChangeHandler}
                      />
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color">قیمت واحد (تومان) </label>
                      <input
                        style={{ direction: "rtl" }}
                        className={styles.inputSty}
                        name="default_price"
                        value={addCommas(otherInfo.default_price)}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color">وزن از</label>
                      <input
                        className={styles.inputSty}
                        style={{ direction: "rtl" }}
                        name="default_weight_from"
                        value={addCommas(otherInfo.default_weight_from)}
                        onChange={handleChange}
                        placeholder="وزن از"
                      />
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color">وزن تا</label>
                      <input
                        style={{ direction: "rtl" }}
                        className={styles.inputSty}
                        type="number"
                        name="default_weight_to"
                        value={addCommas(otherInfo.default_weight_to)}
                        onChange={handleChange}
                        placeholder="وزن تا"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color">دسته بندی</label>
                      <select
                        name="cat_id"
                        class="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        style={{
                          direction: "rtl",
                          color: "rgb(100, 100, 100)"
                        }}
                        className={styles.inputSty}
                        value={otherInfo.cat_id}
                        onChange={inputChangeHandlerDaste}
                      >
                        <option selected hidden value="-1" disabled>
                          {" "}
                          انتخاب کنید
                        </option>
                        {allLeader?.map((value, index) => (
                          <option key={index} value={index}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color">لاین</label>
                      <Select
                        className=" inputSty "
                        options={test}
                        value={otherInfo.line_id}
                        onChange={changeHandleraTags}
                        // options={tagsOptions}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                        // value={defaultTags}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox mb-2">
                      <label className="m-1 color"> ساب لاین </label>
                      <Select
                        className=" inputSty "
                        options={subLine}
                        value={otherInfo.sub_line_id}
                        onChange={changeHandleraSubLines}
                        // options={tagsOptions}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                        // value={defaultTags}
                      />
                    </div>
                    {/* انتخاب بهترین فروشگاه */}
                    <div className="widyhBox">
                      <label className="m-1 color">
                        {" "}
                        انتخاب بهترین فروشگاه{" "}
                      </label>
                      <Select
                        className=" inputSty "
                        options={bestSupplier}
                        placeholder={<div> انتخاب کنید</div>}
                        value={otherInfo.best_supplier_id}
                        onChange={e => {
                          setOtherInfo(prev => {
                            return { ...prev, best_supplier_id: e };
                          });
                        }}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                      />
                    </div>
                  </div>
                  <div
                    class="accordion-item mt-3"
                    style={{ borderRadius: "12px" }}
                  >
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        style={{
                          borderRadius: "12px",
                          borderTop: "1px solid #ddd"
                        }}
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        آپشن جدید
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        {" "}
                        <TodoApp
                          todos={todos}
                          setTodos={setTodos}
                          allUserTag={allUserTag}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={inputElement}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  postHandler(otherInfo);
                }}
                disabled={disabledBtn}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditProduct;
{
}
